import * as types from "./actionTypes";

const initialState = {
  formUrl: null,
  error: null
};

export default function(state = initialState, action) {
  switch (action.type) {
    case types.CREATE_ORDER_SUCCESS:
      return {
        formUrl: action.payload.form_url
      };

    case types.CREATE_ORDER_FAIL:
      return {
        ...state,
        error: true,
        errorMessage: action.payload.errorMessage
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/order/reducer.js